inputs-search-radio-order
  div(class="form-group row { error: opts.errors }")
    label.col-md-4.col-form-label
      | {opts.label}
      span.text-danger(if="{ opts.required }") &nbsp;*
    .col-md-8
      span.radio-wrap(each="{item, index in opts.items}")
        input(id="{this.tagScope}_{index}" name="{ parent.opts.name }" type="radio" value="{ item.value }" onClick="{ parent.onChange }" checked="{checked: item.value == parent.opts.value}")
        label(for="{this.tagScope}_{index}") { item.label }
  script(type="typescript").
    this.mixin('inputs.search.radio-order')
  style(scoped).
    .radio-wrap {
      display: inline-block;
      margin-right: .5em;
      margin-top: .5em;
    }
